import { IOrderDTO, IPaginationDTO } from '@/dtos';
import { generatePagination, get } from '../apiWrapper';

export async function getMyOrdersAPI(
  pagination: IPaginationDTO,
): Promise<{ data: IOrderDTO[]; count: number }> {
  const pageOptions = await generatePagination(pagination);
  const orders = await get<{ data: IOrderDTO[]; count: number }>(`/orders${pageOptions}`);
  return orders;
}

export async function getMyOrderAPI(orderId: string): Promise<IOrderDTO> {
  const order = await get<IOrderDTO>(`/order/${orderId}`);
  return order;
}
